import React, {FC,  useEffect, useContext, useState} from 'react';
import {get, post} from "../fetchers/fetchers";
import { useTask, TasksDispatchContext } from '../stateManagement/context';


import {useParams} from "react-router";
 
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid,
    IconButton, InputLabel, MenuItem, Select, TextField, 
    withStyles, makeStyles
} from "@material-ui/core";
import {IDocument} from "../types/types";
import DialogContentText from "@material-ui/core/DialogContentText";
import { getDocuments } from '../stateManagement/data';
import AddIcon from "@material-ui/icons/Add";
import { set } from 'date-fns';
import { API_URL } from "../env";

const useStyles = makeStyles((theme) => ({
    button: {
        display: 'block',
        marginTop: theme.spacing(2),
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 200,
        maxWidth: 200,
    },
    menu:{
        minWidth: 250,
        maxWidth: 250,
    },
    listItem: {
        whiteSpace: "normal",
        fontSize: "11pt"
    }
}));

interface IDocumentsProps {
    updateDocumentID: (documentID: IDocument) => void;
    showTitle?: boolean
    documentID?: number
}

interface IRouteParams {
    id: string
}


const AddingButton = withStyles(theme => ({
    root: {
        margin: "auto",
        backgroundColor: "rgba(0,103,114,0.2)",
        color: "rgba(0,103,114,1)",
        '&:hover': {
            backgroundColor: "rgba(0,103,114,0.5)",
        },
    },
}))(IconButton);

const Documents: FC<IDocumentsProps> = ({updateDocumentID, documentID,showTitle }) => {

    const classes = useStyles();

    let dispatch = useContext(TasksDispatchContext)

    const [documents, setDocuments] = useState<IDocument[]>([]);
    const [openCreateDialog, setOpenCreateDialog] = useState<boolean>(false);
    const [selected, setSelected] = useState(documentID?documentID:-1);
    const [newDocument, setNewDocument] = useState<IDocument>({});
    const [documentRef, setDocumentRef] = useState(documentID?documentID:-1);
    const [write_access, setWriteAccess] = useState<boolean>(false);

    let tasks = useTask()

    const [title, setTitle] = useState(showTitle?showTitle:true);

    const params = useParams<IRouteParams>()

    const addDocument = async (document: IDocument) => {
        let d = {...document};
        d.document_type_id = 1;
        d.uuid = -1;
        await post<IDocument>( API_URL + "documents/" + params.id.toString(), d);
        await getDocuments(params.id, dispatch);
        
  
    }

    const createDocument = () => {
        addDocument(newDocument).then(() => setOpenCreateDialog(false))
        setNewDocument({})
    }

    const handleClose = () => {
        setOpenCreateDialog(false)
    }
    const handleOpen = () => {
        setOpenCreateDialog(true)
    }
    
    useEffect(() => {
        setWriteAccess(tasks.write_access)
    }, [tasks])

    useEffect(() => {
        setDocuments(tasks.documents)  // Assuming consequenceCategories are present in tasks
    },[ tasks.documents])

    type keys = "name" | "reference" | "author" | "filename" | "description" | "date" | "comment";

    const renderField = (label: string, key: keys, type: string) => {
        return <div>
            <div style={{
                width:"100%",
                margin:"auto",
            }}>
                <TextField
                    fullWidth
                    label={label}

                    value={newDocument[key]}
                    onChange={(event) => {
                            let v = (event.target.value as any);
                            let c = {...newDocument};
                            c[key] = v
                            setNewDocument(c)
                    }
                    }
                    type={type}
                />
            </div>
        </div>
    }

    const create_dialog = () => {
        return (
            <Dialog open={openCreateDialog} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Create document</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Add a new reference document
                    </DialogContentText>

                    {renderField("Citation", "name", "string")}
                    {renderField("Title", "reference", "string")}
                    {renderField("Author", "author", "string")}
                    {renderField("Reference", "filename", "string")}
                    {renderField("Description", "description", "string")}
                    {renderField("Comment", "comment", "string")}
                    {renderField("Date", "date", "date")}


                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={createDocument} color="primary">
                        Create
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    return (
        <>
            <Grid container spacing={3}>
                <Grid item xs={9}>
                    {openCreateDialog && create_dialog()}
                    {title && <InputLabel>Reference</InputLabel>}
                    <FormControl className={classes.formControl} size="small">
                    <Select style={{ fontSize:"11pt"}}
                            value={selected}
                            disabled={!write_access}
                            onChange={(event) => {
                                let selection = parseInt(event.target.value as string)
                                let selected_id = documents.find((d) => d?.uuid === selection)
                                if (selected_id) {
                                    if (selected_id) {
                                        updateDocumentID(selected_id)
                                    }
                                    setSelected(selection)
                                }
                            }
                            }>
                        {documents.map((d) => {
                            return <MenuItem value={d.uuid}>{d.name}</MenuItem>
                        })}


                    </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={3}>
                    {write_access && <>
                    <IconButton color="primary" component="span"
                                style={{
                                    margin: "auto",
                                    backgroundColor: "rgb(84,107,213)",
                                    color: "rgb(255,255,255)"
                                }} onClick={() => handleOpen()}>
                        <AddIcon fontSize="small"/>
                    </IconButton>
                    </> }


                </Grid>
            </Grid>
        </>
    );
}

export default Documents;

